import React from 'react';
import { rangeProducts } from '../data/mock';

const SITE_URL = 'https://efamfitness.com';
const HOME_TITLE = 'EMS Body Sculpting Machines Australia | EFAM Fitness';
const HOME_DESCRIPTION =
  'EFAM supplies commercial-grade EMS body sculpting machines for homes, studios and salons - 24 models from the compact SoloForge to the Crown Jewel flagship, priced in AUD with Express worldwide delivery.';

// NOTE ON OFFERS: no Offer / price / availability is published here on purpose.
// Stripe Payment Links are not live yet (see src/lib/checkout.js), so a priced
// rich result would send shoppers to a page with no checkout. Add offers back
// only when the links exist and TJ has approved going live.
const StructuredData = () => {
  const structuredData = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebPage',
        '@id': `${SITE_URL}/#webpage`,
        url: `${SITE_URL}/`,
        name: HOME_TITLE,
        description: HOME_DESCRIPTION,
        isPartOf: { '@id': `${SITE_URL}/#website` },
        about: {
          '@type': 'Thing',
          name: 'EMS body sculpting equipment'
        }
      },
      {
        '@type': 'ItemList',
        '@id': `${SITE_URL}/#range`,
        name: 'EFAM EMS body sculpting range',
        description: 'The full 24-model EFAM range of EMS body sculpting machines.',
        url: `${SITE_URL}/full-range`,
        numberOfItems: rangeProducts.length,
        itemListElement: rangeProducts.map((product, index) => ({
          '@type': 'ListItem',
          position: index + 1,
          item: {
            '@type': 'Product',
            name: product.name,
            description: product.subtitle,
            image: product.image.startsWith('http') ? product.image : `${SITE_URL}${product.image}`,
            brand: {
              '@type': 'Brand',
              name: 'EFAM'
            },
            category: 'EMS body sculpting equipment'
          }
        }))
      }
    ]
  };

  return (
    <script
      id="efam-structured-data"
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
    />
  );
};

export default StructuredData;
